import differenceInDays from 'utils/time/differenceInDays';
import differenceInWeeks from 'utils/time/differenceInWeeks';
import { isDuringWeekend } from './isDuringWeekend';

export function getScholarWeeksBetween(
  startDate?: Date,
  endDate?: Date,
  sundayStart = false,
) {
  if (!startDate || !endDate) {
    return 0;
  }
  if (differenceInDays(endDate, startDate) < 4) {
    return 0;
  }
  if (isDuringWeekend(startDate, sundayStart)) {
    return differenceInWeeks(endDate, startDate);
  }

  return differenceInWeeks(endDate, startDate) + 1;
}
